import BrushButton from "../../components/BrushButton";
import Borders from "../../components/Borders";

// IMAGES //
import borderPage from "../../assets/border_page.png";
import zombieHand from "../../assets/zombie_button_top.jpg";

// STYLES //
import "./warning.css";

export default function Warning({ startMusic, stopMusic }) {
    return (
        <div className="game-page warning-page">
            <Borders image={borderPage} scale={0.98} />

            <div className="warning-content">
                <section className="game-copy">
                    <p>Now then. Before I tell you what happened, there is one small matter worth mentioning.</p>

                    <p>This tale contains children who become zombies, parents who must confront them, and a good deal of general misfortune besides. If you'd rather not hear such things, there's no shame in leaving now.</p>

                    <BrushButton
                        className="warning-button"
                        to="/"
                        onClick={() => stopMusic?.()}
                    >
                        Go Back
                    </BrushButton>
                    
                    <p>If, however, you're determined to see this story through, then pull up a chair. Our tale begins in the vineyards of Valpolicella, in the autumn of <em>1897</em>&hellip;</p>

                    <BrushButton
                        className="warning-button"
                        to="/createzombie"
                    >
                        Continue the Tale
                    </BrushButton>

                </section>
            </div>

            {/* <div className="warning-image-wrapper">
                <img
                    className="warning-image"
                    src={zombieHand}
                    alt="Smiling baby zombie reaching out."
                />
            </div> */}
        </div>
    );
}